import { userRoles } from "../contexts/AuthProvider";

export const rolesDashboards = {
  [userRoles.ADMIN]: "/dashboard",
  [userRoles.USER]: "/dashboard",
};
